export default __webpack_public_path__ + "static/media/arrow-small-right.25a5dead.svg";